import * as React from 'react';

import Layout from '../../components/Layout/index';
import TitleBar from '../../components/TitleBar';
import Button from '../../components/Button';

import './style.scss';

const ReportsPage = () => {
  const reports = [
    {
      title: 'Professional Standards Councils combined annual report, 21/22',
      link: '/pdfs/Professional_Standards_Councils_Annual_Report_2021-22.pdf',
      label: 'Download (7.4MB)',
      icon: 'download',
      color: 'tertiary',
    },
    {
      title: 'View All Reports',
      link: 'https://psc.gov.au/news-and-publications/annual-reports',
      label: 'Go to PSC website',
      icon: 'link',
      color: 'white',
    },
  ];

  return (
    <Layout pageTitle="Reports">
      <TitleBar title="Reports" />
      <section className="l-reports">
        <div className="container">
          <div className="grid">
            {reports.map((report, i) => (
              <div
                key={i}
                className={`card is-${report.color}`}
                data-sal="slide-up"
                data-sal-duration="1000"
                data-sal-delay="300"
                data-sal-easing="ease"
              >
                <div className="title">{report.title}</div>
                <Button
                  openInNewTab
                  isAction
                  label={report.label}
                  to={report.link}
                  icon={report.icon}
                  onClick={() => window.gtag('event', `Reports - ${report.label}`)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ReportsPage;
